import logo from './logo.svg';
// import '@progress/kendo-theme-default/dist/all.css';
import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Login from "./components/login/Login";
import React, {useEffect, useState} from 'react';
import NavigationContainer from "./navigation/NavigationContainer";
import Home from "./components/home/Home";
import Projects from "./components/projects/Projects";
import Tms from "./components/tms/Tms";
import Expenses from "./components/expenses/Expenses";
import useOwnRightsStore from "./stores/OwnRightsStore";
import useClientStore from "./stores/ClientStore";
import * as PropTypes from "prop-types";

function Redirect(props) {
    return null;
}

Redirect.propTypes = {to: PropTypes.string};

function App() {

    const [userAPIKey, setUserAPIKey] = useState(sessionStorage.getItem("apiKEY"))
    const {selectedClient, setSelectedClient} = useClientStore((state) => ({selectedClient: state.selectedClient, setSelectedClient: state.selectClient}))

    const [openNew, setOpenNew] = useState(false)

    // const loadRights = useOwnRightsStore(state => state.loadAll)

    // if (selectedClient == null) {
    //     return <Redirect to="/" />;
    // }

    return (

      <>

        {!userAPIKey && <>

          <Login setUserApiKey={setUserAPIKey} />

        </>}

          {userAPIKey &&
              <React.Fragment>
                  <HashRouter>
                      <NavigationContainer>
                          <Routes>
                              <Route exact={true} path="/" element={<Home />}/>
                              <Route exact={true} path="/clients" element={<Home />}/>
                              <Route exact={true} path="/projects" element={<Projects setOpenNew={setOpenNew} />}/>
                              <Route exact={true} path="/tms" element={<Tms openNew={openNew} setOpenNew={setOpenNew} />}/>
                              <Route exact={true} path="/expenses" element={<Expenses />}/>
                          </Routes>
                      </NavigationContainer>
                  </HashRouter>
              </React.Fragment>
          }

      </>

    );
    }

export default App;
